// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1IGeA","title":"FrontImage_title__18Tml"};